<template>
  <el-dialog
    custom-class="es-dialog"
    :visible.sync="dialogVisible"
    :center="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    :destroy-on-close="true"
    width="600px"
  >
    <div slot="title" class="dialog-title">
      <span
        >{{ $t("message.home.addAddress") }}/{{
          $t("message.home.modifyAddress")
        }}</span
      >
    </div>
    <div class="add-address-content">
      <el-form :model="formData" :rules="rules" ref="addressForm">
        <el-form-item prop="contacts">
          <el-input
            v-model="formData.consignee"
            :placeholder="$t('message.home.consigneeName')"
            :maxlength="64"
          />
        </el-form-item>
        <!-- <el-form-item prop="email">
          <el-input
            v-model="infoModel.email"
            :placeholder="$t('message.home.orderEmail')"
            :maxlength="64"
          />
        </el-form-item> -->
        <el-form-item prop="phone">
          <div class="form-phone">
            <el-input
              v-model="formData.phone"
              :placeholder="$t('message.home.pleaseSetMobileNumber')"
              :maxlength="20"
            ></el-input>
            <VueCountryIntl
              v-model="infoModel.areaCode"
              schema="popover"
              :searchInputPlaceholder="$t('message.home.pleaseSetAreaCode')"
              noDataText="No data found"
            >
              <div class="area-code flex-between" slot="reference">
                <span>+{{ infoModel.areaCode || "" }}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>
            </VueCountryIntl>
          </div>
        </el-form-item>
        <div class="check_address">
          <el-form-item prop="country">
              <el-select
                v-model="currentCountry"
                :placeholder="$t('message.home.nation')"
                filterable
              >
              <el-option
                v-for="(item,index) in countryList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
                @click.native="countryListChange(index)"
              >
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="prov-city" >
              <div v-if="prov && editC">{{ prov }}</div>
              <div v-if="itemCity && editC">{{ itemCity }}</div>
            </div>
          </el-form-item>
          <el-form-item prop="province" >
            <el-select
              v-model="currentProvince"
              :placeholder="$t('message.home.state')"
              filterable             
            >
              <el-option
                v-for="(item,index) in provinces"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                @click.native="provinceListChange(index)"
              >
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="city" >
            <el-select
              v-model="currentCity"
              :placeholder="$t('message.home.city')"
              filterable
            >
              <el-option
                v-for="(item,index) in cities"
                :key="item.id"
                :label="item.name"
                :value="item.id"   
                
                @click.native="cityListChange(index)"             
              >
                <span style="float: left">{{ item.name }}</span>
                <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.value
                }}</span> -->
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item prop="postcode">
          <el-input
            v-model="formData.zipCode"
            :placeholder="$t('message.home.postCode')"
            :maxlength="32"
          />
        </el-form-item>
        <el-form-item prop="address">
          <el-input
            v-model="formData.address"
            :placeholder="$t('message.home.address')"
            type="textarea"
            :rows="4"
            :maxlength="255"
          />
        </el-form-item>
        <el-form-item>
          <div class="flex-between">
            <span>{{ $t("message.home.desc") }}</span>
            <el-switch
              v-model="formData.isDefault"
              active-color="var(--color-main)"
              inactive-color="#ECECEC"
              :active-value="true"
              :inactive-value="false"
            ></el-switch>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="submit-btn flex-center">
            <el-button type="primary" :loading="loading" @click="submitForm">
              {{ $t("message.home.btnSure") }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import VueCountryIntl from "vue-country-intl";
import common from "@/util/common";
import "vue-country-intl/lib/vue-country-intl.css";
// import { apiListCountry, apiListState, apiListCity } from "@/api/userCenter";
import { BASE_AREA_CODE } from "@/common";


////////////////////////////////////////////////////////////////////////////

import {
		list,
		add,
		save,
		edit,
		update,
		del
	} from '@/api/upms/address.js'

////////////////////////////////////////////////////////////////////////////


export default {
  name: "EsAddress",
  components: { VueCountryIntl },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    addressItemData: {
      type: Object,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    prov: {
      type: String,
      default: "",
    },
    itemCity: {
      type: String,
      default: "",
    }
  },
  model: {
    prop: "show",
    event: "update",
  },
  data() {
    return {
      changeCounty: false,
      dialogVisible: false,
      infoModel: {
        consignee: "",
        // email: "",
        phone: "",
        postcode: "",
        regionId:"",
        // country: "",
        // province: "",
        // city: "",
        address: "",
        use: 1,
        areaCode: BASE_AREA_CODE,
      },
      isProvince: true,
      isCity: true,
      editC: false,
      countryList: [],
      
      provinces: [],
      cities: [],
      value: "",
      rules: {
        consignee: [
          common.ruleUtils.getRule(
            "required",
            `${this.$t("message.home.pleaseInput")}${this.$t(
              "message.home.consigneeName"
            )}`
          ),
        ],
        // email: [
        //   common.ruleUtils.getRule(
        //     "required",
        //     `${this.$t("message.home.pleaseInput")}${this.$t(
        //       "message.home.orderEmail"
        //     )}`
        //   ),
        //   common.ruleUtils.getRule("email"),
        // ],
        phone: [
          common.ruleUtils.getRule(
            "required",
            `${this.$t("message.home.pleaseSetMobileNumber")}`
          ),
          common.ruleUtils.getRule("phone"),
        ],
        regionId: [
          common.ruleUtils.getRule(
            "required",
            `${this.$t("message.home.pleaseInput")}${this.$t(
              "message.home.pleaseSetAreaCode"
            )}`
          ),
        ],
        // country: [
        //   common.ruleUtils.getRule(
        //     "required",
        //     `${this.$t("message.home.pleaseInput")}${this.$t(
        //       "message.home.nation"
        //     )}`
        //   ),
        // ],
        // province: [
        //   common.ruleUtils.getRule(
        //     "required",
        //     `${this.$t("message.home.pleaseInput")}${this.$t(
        //       "message.home.state"
        //     )}`
        //   ),
        // ],
        // city: [
        //   common.ruleUtils.getRule(
        //     "required",
        //     `${this.$t("message.home.pleaseInput")}${this.$t(
        //       "message.home.city"
        //     )}`
        //   ),
        // ],
        zipCode: [
          common.ruleUtils.getRule(
            "required",
            `${this.$t("message.home.pleaseInput")}${this.$t(
              "message.home.postCode"
            )}`
          ),
          common.ruleUtils.getRule("fourMoreNumber"),
        ],
        address: [
          common.ruleUtils.getRule(
            "required",
            `${this.$t("message.home.pleaseInput")}${this.$t(
              "message.home.address"
            )}`
          ),
        ],
      },
      loading: false,

      ////////////////////////////////////////////////////////////////////////////////////


      currentPage: 1,
				// 设置加载的第几次，默认是第一次  
				pageSize: 10,
				//返回数据的个数  
				orderBy: "",
				//排序字段
				orderType: "",
				//排序 asc正 desc反
				searchLoading: false,
				//"上拉加载"的变量，默认false，隐藏  
				searchLoadingComplete: false,
				//“没有数据”的变量，默认false，隐藏 
				objsList: [],

				editFlag: "add",
				userInfo: {},
				index: 0,

				loadingText: '加载中...',
				loadingHidden: false,
				multiArray: [
					// [app.globalData.messages['Region_demo0']],
					// [app.globalData.messages['Region_demo1']],
					// [app.globalData.messages['Region_demo2']]
          ['北京'],
					['北京'],
					['北京']
				],
				multiIndex: [0, 0, 0],
				formData: {
					isDefault: true,
          consignee: "",
          phone: "",
          postcode: "",
          regionId:"",
          regionName:"",
          address: "",
          
				},
        currentCountry:"",
        currentProvince:"",
        currentCity:"",
				addressId: "",
				regionId: "",

				// rules: {
				// 	consignee: {
				// 		rules: [{
				// 			required: true,
				// 			errorMessage: app.globalData.messages['Address_consignee']+' '+app.globalData.messages['common_notNull']
				// 		}]
				// 	},
				// 	phone: {
				// 		rules: [{
				// 			required: true,
				// 			errorMessage: app.globalData.messages['Address_phone']+' '+app.globalData.messages['common_notNull']
				// 		}]
				// 	},
				// 	regionId: {
				// 		rules: [{
				// 			required: true,
				// 			errorMessage: app.globalData.messages['Address_region']+' '+app.globalData.messages['common_notNull']
				// 		}]
				// 	},
				// 	address: {
				// 		rules: [{
				// 			required: true,
				// 			errorMessage: app.globalData.messages['Address_address']+' '+app.globalData.messages['common_notNull']
				// 		}]
				// 	},

				// },


      /////////////////////////////////////////////////////////////////////////////////////




    };
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue !== oldValue) this.$emit("update", newValue);
    },
    show(newValue, oldValue) {
      if (newValue !== oldValue) this.dialogVisible = newValue;
      if (!newValue) {
        for (const key in this.infoModel) {
          if (key === "use") {
            this.infoModel[key] = 0;
          } else if (key === "areaCode") {
            this.infoModel[key] = BASE_AREA_CODE;
          } else {
            this.infoModel[key] = "";
          }
        }
      }
    },
    // data: {
    //   handler(newValue, oldValue) {
    //     if (newValue && Object.keys(newValue)) {
    //       if (newValue.phone) {
    //         let phoneArr = newValue.phone.split(" ");
    //         this.formData = {
    //           ...newValue,
    //           ...{ phone: phoneArr[1], areaCode: phoneArr[0] },
    //         };
    //       } else {
    //         this.formData = {
    //           ...newValue,
    //         };
    //       }
    //     }
    //   },
    //   immediate: true,
    // },
    // "infoModel.country": {
    //   handler(newValue, oldValue) {
    //     this.infoModel.province = "";
    //     this.getProvinceList(newValue);
    //   },
    // },
    // "infoModel.province": {
    //   handler(newValue, oldValue) {
    //     this.provinces.length > 0 && (this.infoModel.city = "");
    //     if (this.infoModel.province) {
    //       this.getCityList(newValue);
    //     }
    //   },
    // },
  },
  created() {
    // this.getCountry();
  },
  mounted() {
    this.dialogVisible = this.show;
    // if (!this.formData) {
      // this.getCountry();
      // this.address_add();
    // }

    // this.addressId = options.id;
			if (this.addressItemData&&this.addressItemData.id && this.addressItemData.id != "") {
				this.address_edit();
        this.formData=this.addressItemData;
			} else {
				this.address_add();
			} //调用应用实例的方法获取全局数据

    this.editC = this.isEdit
  },
  methods: {
    ...mapActions("user", ["requestAddressAdd", "requestAddressEdit"]),
    async getCountry() {
      this.changeCounty = true;
      
      // this.isEdit = false
      this.editC = false
      this.isCity = false
      const result = await apiListCountry();
      this.countryList = result.data?.data || [];
    },
    // async getProvinceList(id) {
    //   this.infoModel.city = "";
    //   const res = await apiListState({ countryId: id });
    //   this.provinces = res.data?.data || [];
    //   this.cities = [];
    //   this.isProvince = true;
    //   this.isCity = true;
    //   if (this.provinces.length == 0) {
    //     this.isProvince = false;
    //     this.isCity = false;
    //   }
    // },
    // async getCityList(id) {
    //   if (id) {
    //     const res = await apiListCity({ stateId: id });
    //     this.cities = res.data?.data || [];
    //     this.isCity = true;
    //   }

    //   if (this.cities.length == 0) {
    //     this.isCity = false;
    //   }
    // },
    add() {
      this.$refs.addressForm.validate(async (valid) => {
        this.infoModel.contacts = encodeURIComponent(this.infoModel.contacts);
        if (valid) {
          try {
            this.loading = true;
            const params = {
              ...this.infoModel,
              countryId: this.countryList.find(
                (x) => x.id == this.infoModel.country
              )?.id ?? this.infoModel.countryId ?? 0,
              country:
                this.countryList.find((x) => x.id == this.infoModel.country)
                  ?.countryName ?? this.infoModel.country ?? "",
              province:
                this.provinces.find((x) => x.id === this.infoModel.province)
                  ?.stateName ?? "",
              provinceId: this.provinces.find(
                (x) => x.id === this.infoModel.province
              )?.id  ?? 0,
              cityId: this.cities.find((x) => x.id == this.infoModel.city)
                ?.id ?? 0,
              city:
                this.cities.find((x) => x.id == this.infoModel.city)
                  ?.cityName ?? "",
              phone: this.infoModel.areaCode + " " + this.infoModel.phone,
              regionId: this.currentCity || this.currentProvince || this.currentCountry || this.infoModel.regionId,
              regionName: this.formData.regionName || (this.city || this.province || this.country),
              isDefault: true,
            };
            params.province == '' && delete params.province
            params.city == '' && delete params.city
            if (this.isEdit) {
              await this.requestAddressEdit(params);
            } else {
              await this.requestAddressAdd(params);
            }
            this.$message({
              type: "success",
              message: this.$t("message.home.operationSuccess"),
            });
            this.dialogVisible = false;
          } finally {
            this.loading = false;
          }
        }
      });
    },




///////////////////////////////////////////////////////////////////////////////////////////

address_add: function() {
				//获取用户订单数据
				add().then(response => {
					var regions = response.data.data.regions;
					// var multiArray = new Array();
					var array1 = [];
					// var array2 = [];
					// var array3 = [];
					var index = 0;
					for (var i = 0; i < regions.length; i++) {
						if (regions[i].level == 0) {
							array1[index] = regions[i];
							index++;
						}
					}

          this.countryList=array1;


					// if (array1[0] && array1[0].children) {
					// 	array2 = array1[0].children;
					// }
					// if (array1[0] && array2[0].children) {
					// 	array3 = array2[0].children;
					// }
					// multiArray[0] = array1;
					// multiArray[1] = array2;
					// multiArray[2] = array3;
					// this.formData.regionId = multiArray[2][0].id;
					// this.multiArray = multiArray;
					// this.formData.regionName = this.multiArray[0][this.multiIndex[0]].name + "," + this
					// 	.multiArray[1][this.multiIndex[1]].name + "," + this.multiArray[2][this.multiIndex[2]]
					// 	.name;


				}).catch(error => {
          this.loading=false;
					console.error("error", error);
					// uni.showToast({
					// 	title: this.messages['common.message.upgradeRequired'],
					// 	duration: 2000
					// });
				})
			},

    countryListChange(index) {
      this.provinces=this.countryList[index].children;
      this.formData.regionId=this.countryList[index].id;
      this.formData.regionName=this.countryList[index].name;
    },

    provinceListChange(index){
      this.cities=this.provinces[index].children;
      this.formData.regionId=this.provinces[index].id;
      this.formData.regionName=this.provinces[index].name;
    },

    cityListChange(index){
      this.formData.regionId=this.cities[index].id;
      this.formData.regionName=this.cities[index].name;
    },
			address_edit: function() {
        this.loading=true;
				edit({
					'id': this.addressItemData.id
				}).then(response => {
          this.loading=false;
					this.formData = response.data.data.address;
					// this.order_update_init();

					let regionId = this.formData.regionId;
					let regions = response.data.data.regions;
					let array1 = [];
					let array2 = [];
					let array3 = [];

					var index = 0; //如果是update
					for (let x = 0; x < regions.length; x++) {
						if (regions[x].level == 0) {
							array1[index] = regions[x];
							index++;
						}
					}
					let updatemultiIndex = [0, 0, 0];
					if (regionId) {
						this.multiArray[0] = array1;
            //编辑第一列
            this.countryList=array1;
						for (let i = 0; i < array1.length; i++) {
							if (array1[i].id == regionId) { //在第一层找到了
								updatemultiIndex[0] = i;
                this.currentCountry=this.countryList[i].id;
                // this.currentProvince=this.provinces[j].id;
                // this.currentCity=this.cities[f].id;

								this.multiIndex = updatemultiIndex;
								return;
							}
							if (array1[i].children) {
								array2 = array1[i].children; //在第二层查找
								this.multiArray[1] = array2;

                //编辑第二列
                this.provinces=array2;
								for (let j = 0; j < array2.length; j++) {
									if (array2[j].id == regionId) {
										updatemultiIndex[1] = j;
										updatemultiIndex[0] = i;
                    this.currentCountry=this.countryList[i].id;
                    this.currentProvince=this.provinces[j].id;
                    // this.currentCity=this.cities[f].id;
										// this.multiIndex = updatemultiIndex;
										return;
									}
									if (array2[j].children) {
										array3 = array2[j].children; //在第三次查找
										this.multiArray[2] = array3;

                    //编辑第三列
                    this.cities=array3;
										for (let f = 0; f < array3.length; f++) {
											if (array3[f].id == regionId) {
												// updatemultiIndex[2] = f;
												// updatemultiIndex[1] = j;
												// updatemultiIndex[0] = i;
                        this.currentCountry=this.countryList[i].id;
                        this.currentProvince=this.provinces[j].id;
                        this.currentCity=this.cities[f].id;

												// this.multiIndex = updatemultiIndex;
												return;
											}
										}
									}
								}
							}
						}
					}
				}).catch(error => {
					this.loading=false;
					console.error("error", error);
					// uni.showToast({
					// 	title: this.messages['common.message.upgradeRequired'],
					// 	duration: 2000
					// });
				})
			},

			changeRegionMultiColumn: function(e) {
				var multiArray = this.multiArray;
				var multiIndex = [this.multiIndex[0], this.multiIndex[1], this.multiIndex[2]];
				switch (e.detail.column) {
					case 0:
						//选择第一列
						//给第二列
						if (multiArray[0][e.detail.value].children.length != 0) {
							multiIndex[0] = e.detail.value;
							multiIndex[1] = 0;
							multiArray[1] = multiArray[0][e.detail.value].children; //第二列仅有一个值，要给第三列重新赋值
							if (multiArray[0][e.detail.value].children.length >= 1) {
								multiArray[2] = multiArray[1][0].children;
								multiIndex[2] = 0;
							}
						} else {
							multiArray[1] = [];
							multiArray[2] = [];
						}
						break;
					case 1:
						//选择第二列      
						//给第三列赋值
						multiIndex[1] = e.detail.value;
						multiIndex[2] = 0;
						multiArray[2] = multiArray[1][e.detail.value].children;
						break;
					case 2:
						//选择第三列      
						multiIndex[2] = e.detail.value;
						break;
				}
				this.multiArray = multiArray;
				this.multiIndex = multiIndex;
			},

			changeRegionMulti: function(e) {
				var multiArray = this.multiArray;
				var multiIndex = e.detail.value;
				var regionId = "";
				if (multiArray[2][multiIndex[2]].id) {
					regionId = multiArray[2][multiIndex[2]].id;
				} else {
					if (multiArray[1][multiIndex[1]].id) {
						regionId = multiArray[1][multiIndex[1]].id;
					} else {
						regionId = multiArray[0][multiIndex[0]].id;
					}
				}
				this.multiIndex = e.detail.value;
				this.formData.regionId = regionId;
				this.formData.regionName = this.multiArray[0][this.multiIndex[0]].name + "," + this.multiArray[1][this
					.multiIndex[1]
				].name + "," + this.multiArray[2][this.multiIndex[2]].name;
			},

			changeDefaultAddr() {
				this.formData.isDefault = !this.formData.isDefault;
			},

			/** 提交按钮 */
			submitForm() {
        this.$refs.addressForm.validate(async (valid) => {
        // this.infoModel.conacts = encodeURIComponent(this.infoModel.contacts);
        if (valid) {

					if (this.formData.id != null) {
						this.address_update();
					} else {
						this.address_save();
					}

        }
      });
    //  },

		},

			address_save() {
				save(this.formData).then(response => {

          this.$message({
              type: "success",
              message: this.$t("message.home.operationSuccess"),
          });
          this.dialogVisible = false;
          this.loading = false;
          this.$emit('parent-refresh');

					// uni.showToast({
					// 	title: this.messages['common_saveSuccess'],
					// 	duration: 3000,
					// 	icon: "none"
					// });
					// uni.navigateBack({
					// 	url: "../../upms/address/address"
					// })
				});
			},

			address_update() {
				update(this.formData).then(response => {

          this.$message({
              type: "success",
              message: this.$t("message.home.operationSuccess"),
          });
          this.dialogVisible = false;
          this.loading = false;

					// uni.showToast({
					// 	title: this.messages['common_saveSuccess'],
					// 	duration: 3000,
					// 	icon: "none"
					// });
					// uni.navigateBack({
					// 	url: "../../upms/address/address"
					// })

				})
			},


///////////////////////////////////////////////////////////////////////////////////////////



  },
};
</script>

<style lang="scss">
html[dir="rtl"]{
  .el-form-item v::deep .el-form-item__content v::deep .el-form-item__error{
    right: 0;
    left: auto;
  }
  .es-dialog .dialog-title{
    width: 100%;
  }
  .add-address-content .form-phone .area-code span{
    padding-left: 0;
    padding-right: 8px;
  }
  .add-address-content .form-phone .area-code{
    width: 60px;
    padding-left: 10px;
  }
  .el-form-item v::deep .el-form-item__label{
    float: right;
  }
}
.vue-country-item.selected .selected-text{
  display: none;
}
.add-address-content {
  .check_address {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
  }

  .form-phone {
    position: relative;
    cursor: pointer;

    .el-input__inner {
      padding-left: 100px;
    }

    .vue-country-popover-container {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }

    .area-code {
      width: 80px;

      span {
        display: inline-block;
        width: 50px;
        padding-left: 8px;
      }
    }
  }

  .submit-btn {
    width: 100%;
    cursor: pointer;

    .el-button {
      width: 100%;
      height: 50px;
      max-width: 450px;
      padding: 0;
    }
  }
}
.prov-city {
  display: flex;
  div {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    max-width: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:nth-child(2) {
      margin-left: 20px;
    }
  }
}
.vue-country-intl-popover {
  z-index: 9999;

  .vue-country-item.selected {
    background-color: var(--color-main);
  }

  .vue-country-item:not(.selected):hover {
    background-color: var(--color-main);
  }
}
</style>
